import React from 'react';
import SelectInput from 'react-select';

export function FilterSelect({ column, options, setFilter }: any) {
  const { id, Header, preFilteredRows } = column;
  options = React.useMemo(() => {
    const optionsSet = new Set();
    preFilteredRows.forEach((row: { values: { [x: string]: unknown } }) => {
      optionsSet.add(row.values[id]);
    });
    const presentOptions = optionsSet.values();
    if (!options) {
      return Array.from(presentOptions);
    } else {
      return options.filter((option: any) => {
        return Array.from(optionsSet.values()).includes(option);
      });
    }
  }, [id, preFilteredRows, options]);

  return (
    <div style={{ width: 250 }}>
      <SelectInput
        options={options.map((option: any) => {
          return { value: option, label: option };
        })}
        onChange={(object: any) => {
          if (object && object.value) {
            setFilter(id, object.value);
          } else {
            setFilter(id, undefined);
          }
        }}
        placeholder={Header}
        isClearable={true}
      />
    </div>
  );
}

export function FilterSelectCardStatus({ column, setFilter }: any) {
  const options = ['Inactive', 'Assigned', 'Active', 'Visitor', 'Pending Return'];
  return <FilterSelect options={options} column={column} setFilter={setFilter} />;
}
